module.exports = __webpack_public_path__ + "img/pancake-syrup.5df4b98e.jpg";